import { useQuery } from 'react-query';
import apiEndPoints from 'services/apiEndPoints';
import makeApiRequest from 'services/makeApiRequest';

import createQueryParamsForGetReq from 'helper/createQueryParamsForGetReq';

export default function useGetSpecificTaskMembers(id) {
  return useQuery(['get-specific_task_members', id], async () => {
    const res = await makeApiRequest.get(
      createQueryParamsForGetReq(apiEndPoints.PROJECT_TASK_API, {
        id: id,
      })
    );
    return res.data;
  });
}
